import "./index.css";
import { buildDays } from "../History";
import { tickedSlots } from "../../sync/doc";

/**
 * The paper face: the same week as a plain printed grid.
 * Rendered for print only; nothing renders it on screen.
 */
function Paper(props) {
  const { slotNames, ticks, dateFormat, weekdayFormat, showWeekdays, title, shouldPrintHeader, className = "" } = props;
  const days = buildDays(props);
  const displayFormat = showWeekdays ? `${dateFormat} (${weekdayFormat})` : dateFormat;

  return (
    <div className={`Paper ${className}`.trim()} data-weekdays={showWeekdays ? weekdayFormat : undefined}>
      {shouldPrintHeader && title ? <h2 className="Paper-title">{title}</h2> : null}
      <table className="Paper-grid">
        <thead>
          <tr>
            <th scope="col" className="Paper-date">
              Date
            </th>
            {slotNames.map((name, i) => (
              <th scope="col" key={`${i}-${name}`}>
                {name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {days.map((day) => {
            const key = day.valueOf();
            const checked = tickedSlots(ticks, day);
            return (
              <tr key={key}>
                <th scope="row" className="Paper-date">
                  {day.format(displayFormat)}
                </th>
                {slotNames.map((name, i) => {
                  const done = checked.includes(name);
                  return (
                    <td key={`${i}-${name}`}>
                      <span className={`Paper-box${done ? " is-done" : ""}`} aria-hidden="true">
                        {done ? (
                          <svg
                            viewBox="0 0 24 24"
                            width="12"
                            height="12"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M5 12.5l4.5 4.5L19 7.5" />
                          </svg>
                        ) : null}
                      </span>
                      {/* The name is printed once, in the header this cell sits
                          under, and `thead` repeats on every page. Repeating it in
                          every cell said nothing new and cost the checkbox most of
                          its column: at eight columns the label had 9.2mm and was
                          cut to "New…", while the box it belongs to had 4.2mm. */}
                      <span className="sr-only">{`${name} — ${done ? "done" : "not done"}`}</span>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Paper;
